import {first} from 'lodash';
import React, {Component} from 'react';
import styles from './FieldSelection.module.scss';

export default class FieldSelection extends Component {
    componentDidMount() {
        if (this.props.fields.length == 1) {
            this.handleFieldSelection(first(this.props.fields));
        }
    }
    render() {
        return (
            <div className={[this.props.className ?? '', styles.FieldSelection].join(' ')}>
                {this.props.fields.map((field, i) => (
                    <button
                        type="button"
                        className={['btn', 'btn-default', styles.field].join(' ')}
                        onClick={this.handleFieldSelection.bind(this, field)}
                        key={i}
                        title={field.label}>
                        {field.label}
                    </button>
                ))}
            </div>
        );
    }
    handleFieldSelection(field) {
        this.props.onSelect(field);
    }
}
